module.exports = __webpack_public_path__ + "img/21.e2bdd441.png";